import {setCookie, getCookie, eraseCookie} from '../helpers/CookieHelper';

export class HsfRedirectComponent {
  container = null;

  config = null;

  contentHubConfig = null;

  eventConfig = null;

  constructor() {
    this.container = document.querySelector('body');
    if (!this.container) {
      return;
    }

    this.setConfig();
    this.setContentHubConfig();
    this.setEventConfig();

    this.addEventListeners();
    this.setEmailField();
  }

  setConfig() {
    if (typeof THEME_CONFIG === 'undefined') {
      return;
    }

    if (!THEME_CONFIG.hasOwnProperty('hs_redirect_options')) {
      return;
    }

    this.config = THEME_CONFIG.hs_redirect_options.hasOwnProperty('hubspot_redirect') ? THEME_CONFIG.hs_redirect_options.hubspot_redirect : null;
  }

  setContentHubConfig() {
    this.contentHubConfig = typeof CONTENT_HUB_SINGLE_CONFIG === 'undefined' ? null : CONTENT_HUB_SINGLE_CONFIG;
  }

  setEventConfig() {
    this.eventConfig = typeof EVENT_SINGLE_CONFIG === 'undefined' ? null : EVENT_SINGLE_CONFIG;
  }

  addEventListeners() {
    window.addEventListener('message', event => {
      if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmit') {
        this.hsFormSubmitHandler(event.data);
      }
    });
  }

  hsFormSubmitHandler(data) {
    if (this.eventConfig && this.eventConfig.form.overide_redirect_url) {
      setTimeout(() => {
        window.open(this.eventConfig.form.redirect_url, '_self');
      }, 400);

      return;
    }

    if (!this.config) {
      return;
    }

    const redirect = this.getRedirectObjectByFormId(data.id);
    if (!redirect) {
      return;
    }

    this.makeRedirect(redirect, data.data);
  }

  makeRedirect(redirect, data) {
    switch (redirect.type) {
      case 'simple':
        this.simpleRedirect(redirect);
        break;
      case 'second_step_form':
        this.secondStepFormRedirect(redirect, data);
        break;
      case 'external_link_acf':
        this.externalLinkAcfRedirect(redirect);
        break;
    }
  }

  getRedirectObjectByFormId(id) {
    let obj = null;

    const redirects = this.config;
    for (let index in redirects) {
      if (redirects[index].form_id === id) {
        obj = redirects[index];
        break;
      }
    }

    return obj;
  }

  simpleRedirect(redirect) {
    window.open(redirect.redirect_url, this.getWindowNameParameter(redirect.is_new_tab));
  }

  secondStepFormRedirect(redirect, data) {
    eraseCookie('hsf_email');
    setCookie('hsf_email', this.getEmailFromData(data), 1);
    window.open(redirect.redirect_url, this.getWindowNameParameter(redirect.is_new_tab));
  }

  externalLinkAcfRedirect(redirect) {
    if (!this.contentHubConfig) {
      return;
    }

    window.open(this.contentHubConfig.external_link, this.getWindowNameParameter(redirect.is_new_tab));
  }

  getWindowNameParameter(isNewTab) {
    return isNewTab ? '_blank' : null;
  }

  getEmailFromData(data) {
    let email = '';

    for (let index in data) {
      if (data[index].name === 'email') {
        email = data[index].value;
        break;
      }
    }

    return email;
  }

  setEmailField() {
    setTimeout(() => {
      const form = document.querySelector('#hsForm_a1d21556-e525-4142-9409-98a9f2ccd196');
      if (!form) {
        return;
      }

      const email = form.querySelector('.hs-email input[name=email]');
      if (email) {
        let emailValue = this.getEmailFromUrl();
        email.value = emailValue ? emailValue : getCookie('hsf_email');
        const event = new Event('change');
        email.dispatchEvent(event);
      }
    }, 500);
  }

  getEmailFromUrl() {
    const url = new URL(window.location.href);
    const email = url.searchParams.get('hsf_email');

    return email ? email : '';
  }
}